import { ChakraProvider } from "@chakra-ui/react";
import Trends from "./pages/Trends";
import { BrowserRouter, Routes, Route } from "react-router-dom";



function App() {
	return (
		<BrowserRouter basename="/trends">
			<ChakraProvider>
				<main>
					<Routes>
						<Route path="/" element={<Trends/>}/>
					</Routes>
				</main>
			</ChakraProvider>
		</BrowserRouter>
	);
}

export default App;
